export const platformOS = 'web';
